import React from 'react';

import Routes from './routes'

import './styles/global.css';

import AppProvider from './hooks';

function App() {
  return (
    <AppProvider>
      <Routes />
    </AppProvider>
  );
}

export default App;
